import Api from 'api'

const config = {
  baseURL: '/api/app/v1/billing',
}
const api = new Api(config)

api.fetchPaymentMethods = ({ ...rest }) =>
  api.get('/wallet/payment-methods', { ...rest })

api.calculateDeposit = ({ ...rest }) =>
  api.post('/wallet/calculate', { ...rest })

api.topUpDeposit = ({ ...rest }) => api.post('/wallet/deposit', { ...rest })

api.fetchAccountPaymentMethods = ({ accountId, ...rest }) =>
  api.get(`/account/${accountId}/payment-methods`, { ...rest })

api.fetchNetworkPaymentMethods = ({ networkId, ...rest }) =>
  api.get(`/network/${networkId}/payment-methods`, { ...rest })

api.calculateAccount = ({ accountId, ...rest }) =>
  api.post(`/account/${accountId}/calculate`, { ...rest })

api.calculateAccounts = ({ networkId, ...rest }) =>
  api.post(`/network/${networkId}/calculate`, { ...rest })

api.topUpAccount = ({ accountId, ...rest }) =>
  api.post(`/account/${accountId}/deposit`, { ...rest })

api.fetchInvoices = ({ ...rest }) => api.get(`/invoices`, { ...rest })
api.fetchInvoiceById = ({ id, ...rest }) =>
  api.get(`/invoices/${id}`, { ...rest })

api.fetchAutoReplenishSettings = ({ accountId }) =>
  api.get(`/account/${accountId}/auto-replenishment/settings`)

api.submitAutoReplenishSettings = ({ accountId, ...rest }) =>
  api.put(`/account/${accountId}/auto-replenishment/settings`, {
    ...rest,
  })

api.calculateRefund = ({ accountId, ...rest }) =>
  api.post(`/account/${accountId}/refund/calculate`, { ...rest })

api.createRefund = ({ accountId, ...rest }) =>
  api.post(`/account/${accountId}/refund`, { ...rest })

api.fetchPayerSettings = ({ ...rest }) =>
  api.get(`/payer-settings`, { ...rest })

api.calculateDepositCreationFee = ({ accountId, ...rest }) =>
  api.post(`/account/${accountId}/calculate-creation-fee`, { ...rest })

api.depositCreationFee = ({ accountId, ...rest }) =>
  api.post(`/account/${accountId}/deposit-creation-fee`, { ...rest })

api.fetchAccountsMarketplacePaymentMethods = ({ ...rest }) =>
  api.get(`/accounts-marketplace/orders/payment-methods`, { ...rest })

api.accountsMarketplaceCalculate = ({ ...rest }) =>
  api.post(`/accounts-marketplace/orders/calculate`, { ...rest })

api.accountsMarketplaceOrderDeposit = ({ order_id, ...rest }) =>
  api.post(`/accounts-marketplace/orders/${order_id}/deposit`, { ...rest })

export default api
